import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(amount || 0);
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

export function formatDateInput(dateString) {
  if (!dateString) return '';
  return dateString.split('T')[0];
}

export function getStatusColor(estado) {
  const colors = {
    borrador: 'bg-slate-100 text-slate-600',
    enviado: 'bg-blue-100 text-blue-700',
    enviada: 'bg-blue-100 text-blue-700',
    aceptado: 'bg-green-100 text-green-700',
    rechazado: 'bg-red-100 text-red-700',
    pendiente: 'bg-orange-100 text-orange-700',
    en_curso: 'bg-blue-100 text-blue-700',
    pausada: 'bg-yellow-100 text-yellow-700',
    finalizada: 'bg-green-100 text-green-700',
    cancelada: 'bg-red-100 text-red-700',
    cobrada: 'bg-green-100 text-green-700',
    vencida: 'bg-red-100 text-red-700',
    pagado: 'bg-green-100 text-green-700',
    abierta: 'bg-orange-100 text-orange-700',
    en_proceso: 'bg-blue-100 text-blue-700',
    resuelta: 'bg-green-100 text-green-700',
  };
  return colors[estado] || 'bg-slate-100 text-slate-600';
}

export function getGravedadColor(gravedad) {
  const colors = {
    baja: 'bg-green-100 text-green-700',
    media: 'bg-yellow-100 text-yellow-700',
    alta: 'bg-orange-100 text-orange-700',
    critica: 'bg-red-100 text-red-700',
  };
  return colors[gravedad] || 'bg-slate-100 text-slate-600';
}

export function getPrioridadColor(prioridad) {
  const colors = {
    baja: 'bg-green-100 text-green-700',
    media: 'bg-yellow-100 text-yellow-700',
    alta: 'bg-red-100 text-red-700',
  };
  return colors[prioridad] || 'bg-slate-100 text-slate-600';
}

export function translateEstado(estado) {
  const traducciones = {
    borrador: 'Borrador',
    enviado: 'Enviado',
    enviada: 'Enviada',
    aceptado: 'Aceptado',
    rechazado: 'Rechazado',
    pendiente: 'Pendiente',
    en_curso: 'En Curso',
    pausada: 'Pausada',
    finalizada: 'Finalizada',
    cancelada: 'Cancelada',
    cobrada: 'Cobrada',
    vencida: 'Vencida',
    pagado: 'Pagado',
    abierta: 'Abierta',
    en_proceso: 'En Proceso',
    resuelta: 'Resuelta',
  };
  return traducciones[estado] || estado;
}

export function translateCategoria(categoria) {
  const traducciones = {
    material: 'Material',
    mano_obra: 'Mano de Obra',
    transporte: 'Transporte',
    otros: 'Otros',
  };
  return traducciones[categoria] || categoria;
}

export function getTodayISO() {
  return new Date().toISOString().split('T')[0];
}

export function addDaysToDate(dateString, days) {
  const date = new Date(dateString);
  date.setDate(date.getDate() + days);
  return date.toISOString().split('T')[0];
}
